(ns frontend.ui.component.table.style
  (:require
   [garden.util :refer [space-join]]
   [frontend.ui.style.theme.core :as theme]))

(defn tbody
  [_props]
  {:overflow-y "visible"})

(defn tfoot
  [_props]
  {})

(defn tfoot-tr
  [_props]
  ^{:combinators {[:> :th] {:padding-top    ".75em"
                            :padding-bottom ".75em"}}}
  {:border-top       "4px double"
   :border-top-color (theme/color [:table :border])
   :background-color (theme/color [:table :tr :even])})

(defn tr
  [{:keys []}]
  (with-meta
    (merge
     {:overflow-y "hidden"
      :border-top (space-join [(theme/border-width :medium) "solid"
                               (theme/color [:table :border])])}
     (when (= (theme/get-theme) :theme.lp-portal/capman)
       {:border "none"}))
    ;; Meta
    {:pseudo
     {":nth-child(even)"
      {:background-color (theme/color [:table :tr :even])}
      ":nth-child(odd)"
      {:background-color (theme/color [:table :tr :odd])}}}))

(defn th
  [{:keys [styles]}]
  (with-meta
    (merge
     {:padding        (space-join [(theme/edge-size :xsmall) (theme/edge-size :small)])
      :text-align     "left"
      :text-transform "uppercase"
      :font-size      (theme/text-size :xxsmall :size)
      :background     (theme/color [:table :th :bg])
      :border-bottom  "none"
      :color          (theme/color [:table :th :fg])
      :vertical-align :bottom}
     styles
     (when (= (theme/get-theme) :theme.lp-portal/capman)
       {:font-weight    :bold
        :line-height    1.5
        :text-transform "uppercase"
        :border-top     "none"
        :border-bottom  (space-join [(theme/border-width :medium) "solid"
                                     (theme/color [:table :th :border-bottom])])
        :font-size      (theme/text-size :xxxsmall :size)}))

    {:pseudo
     {:first-child
      {:font-weight    :bold
       :position       :sticky
       :z-index        1
       :text-align     :left
       :text-transform "uppercase"
       :left           0}
      :last-child
      {}}}))

(def ^:private variant->style
  {:total     {:padding-bottom "40px"
               :border-top     (space-join [(theme/border-width :medium) "solid"
                                            (theme/color [:table :border])])}

   :highlight {}})

(defn td
  [{:keys [variant vertical-scroll? style]}]
  (with-meta
    (merge
     {:padding        (space-join [(theme/edge-size :xsmall) (theme/edge-size :small)])
      :border-top     (space-join [(theme/border-width :medium) "solid"
                                   (theme/color [:table :border])])
      :border-bottom  (space-join [(theme/border-width :medium) "solid"
                                   (theme/color [:table :border])])
      :vertical-align "middle"
      :text-align     :left
      :font-size      (theme/text-size :xsmall :size)}

     (when (= (theme/get-theme) :theme.lp-portal/capman)
       {:font-size     (theme/text-size :xxsmall :size)
        :border-top    "initial"
        :border-bottom "initial"})
     (when variant
       (variant->style variant))
     style)
    {:pseudo
     {:first-child
      (merge
       {:font-weight      :bold
        :position         :sticky
        :text-align       :left
        :z-index          1
        :text-transform   "uppercase"
        :left             0
        :background-color "inherit"}
       (when vertical-scroll?
         {:background-image
          "linear-gradient(90deg, transparent, transparent calc(100% - 2px), rgba(0,0,0, 0.1) 100%)"
         }))
      :last-child
      {}}}))


(defn table-wrapper
  []
  {:width      "100%"
   :overflow-x "auto"})

(defn table-wrapper-v
  []
  {:overflow-y "visible"})

(defn table
  [{:keys [style]}]
  (merge
   {:width           "100%"
    :overflow-y      "visible"
    :border-collapse "separate"}
   style))

(defn scroll-container
  []
  {:overflow :auto})

(defn table-toolbar
  [capman?]
  (with-meta
    {:position       "absolute"
     :top            (if capman? "-42px" "10px")
     :right          (if capman? "-16px" "16px")
     :height         "30px"
     :font-size "14px"
     :display        "flex"
     :gap            "8px"
     :flex-direction "row"
     :align-items "center"
     :z-index        "10"}
    {}))
